import { atom } from 'jotai';

export const authenticatedAtom = atom(false);
export const userAtom = atom(null);
export const userPopupOpenAtom = atom(false);
